import {MainBanner} from '../../components/main_banner/MainBanner'

export default function Menu() {
    return (
        <>
        <MainBanner/ >
        </>
    )
}